/* Attracta Ankara — Brand JS */

/* ── Accordion ── */
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.aa-accordion__trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.aa-accordion__item');
      const isOpen = item.classList.contains('open');
      item.closest('.aa-accordion').querySelectorAll('.aa-accordion__item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── Product gallery thumbnails ── */
  document.querySelectorAll('.aa-product__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.aa-product__gallery');
      const main = gallery.querySelector('.aa-product__main-img img');
      const src = thumb.querySelector('img').src;
      if (main) { main.src = src; }
      gallery.querySelectorAll('.aa-product__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  /* ── Quantity selector ── */
  document.querySelectorAll('.aa-qty').forEach(qty => {
    const input = qty.querySelector('input');
    qty.querySelector('.aa-qty-minus')?.addEventListener('click', () => {
      const val = parseInt(input.value, 10);
      if (val > 1) input.value = val - 1;
    });
    qty.querySelector('.aa-qty-plus')?.addEventListener('click', () => {
      input.value = parseInt(input.value, 10) + 1;
    });
  });

  /* ── Newsletter form ── */
  document.querySelectorAll('.aa-newsletter__form').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const input = form.querySelector('.aa-newsletter__input');
      const btn   = form.querySelector('.aa-newsletter__btn');
      if (!input.value.includes('@')) return;
      btn.textContent = 'Subscribed!';
      btn.style.background = '#4caf50';
      input.value = '';
      setTimeout(() => { btn.textContent = 'Subscribe'; btn.style.background = ''; }, 3000);
    });
  });
});
